import React from "react";
import FooterSection from "../../components/FooterSection/Footer";
import PricingCard from "../../components/AppSections/ForCompanies/PricingCard";
import CTACompanies from "../../components/AppSections/HomepageSections/CTACompanies";
import {Helmet} from "react-helmet";
import {appLanguage, appWords, WEBSITE_TYPE} from "../../config/Constants";
import {stringsTranslate} from "../../locales/CustomTranslater";
import NewBannerSectionForCompanies from "../../components/AppSections/ForCompanies/NewBannerSectionForCompanies";
import Section2and3ForCompanies from "../../components/AppSections/ForCompanies/Section2and3ForCompanies";
import Section4and5ForCompanies from "../../components/AppSections/ForCompanies/Section4and5ForCompanies";
import Section6and7ForCompanies from "../../components/AppSections/ForCompanies/Section6and7ForCompanies";

export default function ForCompanies() {
    const for_companies_cl = stringsTranslate(appWords.for_companies_cl)
    return (
        <div className={"homepage-4 pt-5 mt-5 banner-section-for-companies"}>
            <Helmet>
                <title>Knaek - {for_companies_cl}</title>
            </Helmet>
            <div className="main">
                <NewBannerSectionForCompanies/>
                <Section2and3ForCompanies/>
                <Section4and5ForCompanies/>
                <Section6and7ForCompanies/>
                {WEBSITE_TYPE === appLanguage.nl && (
                    <PricingCard/>
                )}
                <CTACompanies/>
                <FooterSection/>
            </div>
        </div>
    );
}
